import { Dispatch } from 'redux';
import { categoryGetApi, CategoryGetApiRequest } from '../../../external/CategoryApi';
import { CommonResult } from '../../../external/Common';
import { actions } from '../../modules/Actions';
import { filterConditionState, filterKeyState } from '../../reducers/CurrentFilterReducer';
import { getFilterList } from '../../reducers/FilterListReducer';
import { LOADING_TYPE } from '../../reducers/LoadingStatusReducer';
import { LargeCategory, SearchCategoryState } from '../../reducers/SearchCategoryReducer';
import { SearchConditionState } from '../../reducers/SearchConditionReducer';
import { SORRY_MESSAGE_TYPE } from '../../reducers/SorryMessageReducer';
import { StoreSelectorState } from '../../reducers/StoreSelectorReducer';
import { UserState } from '../../reducers/UserReducer';

export const updateRefresh = (refresh: () => void, dispatch: Dispatch) => {
  dispatch(actions.updateRefresh({ refresh }));
};

export const fetchCustomFilter = async (currentFilterList: filterConditionState[], userId: string, dispatch: Dispatch) => {
  if (currentFilterList.length === 0) {
    dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.CONDITIONS));
    try {
      const filterList = await getFilterList(userId);
      dispatch(actions.filterList.update(filterList));
      dispatch(actions.updateLoadingStatus.done({ params: LOADING_TYPE.CONDITIONS }));
    } catch (error) {
      dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
      dispatch(actions.updateLoadingStatus.failed({ params: LOADING_TYPE.CONDITIONS, error }));
    }
  }
};

export const updateSearchCondition = (searchCondition: SearchConditionState, dispatch: Dispatch) => {
  dispatch(actions.updateSearchCondition(searchCondition));
};

export const updateCurrentFilter = (currentFilter: filterKeyState, dispatch: Dispatch) => {
  dispatch(actions.updateCurrentFilter(currentFilter));
};

export const updateCategory = async (loginUser: UserState, storeSelector: StoreSelectorState, dispatch: Dispatch) => {
  const res: SearchCategoryState = {
    key: { userId: loginUser.crewCd, agencyCd: storeSelector.modalSelectedStores },
    categories: [],
  };
  dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.CATEGORY));
  try {
    const request = makeCategoryApiRequest(loginUser, storeSelector);
    const response = await categoryGetApi(request);
    const result: CommonResult = response.result;
    let resultLargeCategory: LargeCategory[] = [];
    const largeCategory = response.largeCategory;
    if (largeCategory) {
      resultLargeCategory = largeCategory;
    }
    dispatch(actions.updateLoadingStatus.done({ params: LOADING_TYPE.CATEGORY, result }));
    return { ...res, categories: resultLargeCategory };
  } catch (error) {
    console.log(error);
    dispatch(actions.updateLoadingStatus.failed({ params: LOADING_TYPE.CATEGORY, error }));
    return res;
  }
};

function makeCategoryApiRequest(loginUser: UserState, storeSelector: StoreSelectorState): CategoryGetApiRequest {
  const agencyCd: string[] = [...storeSelector.selectedStores];
  const { combiAgencyCd = '' } = loginUser;
  if (combiAgencyCd && !agencyCd.includes(combiAgencyCd)) {
    agencyCd.push(combiAgencyCd);
  }
  const req: CategoryGetApiRequest = {
    userId: loginUser.crewCd,
    // [bugfix]ドロワーで選択した店舗情報でなく、モーダルで選択した店舗の全量をパラメータとしてセットしていたため、改修
    // agencyCd: storeSelector.modalSelectedStores,
    agencyCd,
  };
  return req;
}
